function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('module/Expandable',[],function () {
  'use strict';

  /**
   * Expandable class.
   * 
   * @author Lennart Bergmann <lb@sopg.de>
   * @jira CHEF-220
   * 
   * @created 2021-02-26
   * 
   * @type Expandable
   */
  var Expandable = /*#__PURE__*/_createClass(
  /**
   * Constructor.
   * 
   * @author Lennart Bergmann <lb@sopg.de>
   * @created 2021-02-26
   * 
   * @returns {undefined}
   */
  function Expandable() {
    var _this = this;
    _classCallCheck(this, Expandable);
    /**
     * Setup all expandables.
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @created 2021-02-26
     * @updated 2021-03-26
     * 
     * @returns {undefined}
     */
    _defineProperty(this, "init", function () {
      $(_this.o.sel.clickContainer).each(function (iIndex, oClickContainer) {
        var $clickContainer = $(oClickContainer);
        $clickContainer.on('click', function (oEvent) {
          /* Get clicked click-container. */
          var $clickedElement = $(oEvent.target).closest(_this.o.sel.clickContainer);

          /* Toggle active state. */
          $clickedElement.toggleClass([_this.o.opts.classes.clicked, _this.o.opts.classes.active]);

          /* Toggle explanation. */
          var sData = $clickedElement.data(_this.o.opts.data.cnt);
          $clickContainer.parent().parent().find(_this.o.sel.clickTarget).each(function (iIndex, oClickTarget) {
            var $clickTarget = $(oClickTarget);
            if (sData === $clickTarget.data(_this.o.opts.data.cnt)) {
              $clickTarget.toggleClass(_this.o.opts.classes.hide);
            } else {
              $clickTarget.addClass(_this.o.opts.classes.hide);
            }
          });

          /* Reset other containers. */
          $clickContainer.parent().find(_this.o.sel.clickContainer).each(function (iIndex, oElement) {
            if (oElement !== $clickedElement.get(0)) {
              $(oElement).removeClass([_this.o.opts.classes.clicked, _this.o.opts.classes.active]);
            }
          });
          window.fullpage.reBuild();
        });
      });
    });
    this.o = {
      sel: {
        clickContainer: '.show-n-click-container',
        clickTarget: '.show-n-click-target'
      },
      opts: {
        data: {
          cnt: 'cnt'
        },
        classes: {
          clicked: 'clicked',
          active: 'active',
          hide: 'hide'
        }
      }
    };
    this.init();
  });
  return Expandable;
});

